import { Box, Typography } from "@mui/material";
import useGetSupplies from "./useGetSupplies";
import Page from "../../components/Page";
import Loading from "../../components/Loading";
import SupplyItem from "./SupplyItem";
import useProviderChoice from "../provider/hooks/useProviderChoice";
import ChosenProviderChip from "../provider/components/ChosenProviderChip";
import { useTenant } from "../../contexts/TenantContext";

// About a phone's width: the narrowest a card gets before the row loses a column.
const CARD_MIN_WIDTH = 320;

const SupplyPage = () => {
  const { hasSeveralProviders } = useTenant();
  // The chosen provider's services; every service for „Bárki” and on a tenant with one provider.
  const { providerId } = useProviderChoice();
  const { data, loading } = useGetSupplies(providerId);
  // One photo is enough for every photo-less card to keep an empty frame, so the rows line up.
  const hasAnyImage = !!data?.some((supply) => supply.imageUrl);

  return (
    <Page>
      {hasSeveralProviders && (
        <Box width="100%" mb={{ xs: 3, md: 4 }} display="flex" justifyContent="center">
          <ChosenProviderChip />
        </Box>
      )}

      {loading && <Loading />}
      
      {!loading && data && (
        <>
          {data.length > 0 ? (
            // As many phone-width columns as fit: one on a phone, more side by side the wider
            // the screen. A card never stretches past a column.
            <Box
              width="100%"
              sx={{
                display: "grid",
                gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${CARD_MIN_WIDTH}px), 1fr))`,
                gap: 3,
              }}
            >
              {data.map((supply) => (
                <SupplyItem key={supply.id} supply={supply} showImageSlot={hasAnyImage} />
              ))}
            </Box>
          ) : (
            <Typography variant="h6" component="h1" mt={3} fontWeight="bold" color="primary">
              Nincsenek elérhető szolgáltatások.
            </Typography>
          )}
        </>
      )}
    </Page>
  );
};

export default SupplyPage;
